import uuid from 'uuid/v4'

export function tempIdGenerator(prefix = 'new') {
  return `${prefix}-${uuid()}`
}
